module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t1dreyaqrSaqrTh6O3h6O3h6O3h6O3h6O3h6O31+Prg940cAAAAEXRSTlMAYL//ACDP7///ACCf7/8AMNJWhQgAAACoSURBVHgB7dcxFoMgEIThgQVMhF3M/S8b6KUJU5n9Grv/PUGLwRSibIghDUgpF9lU8gzlQ7YdeYSKEJSEIBQBUSgihIQfev3oD0Me8pCHPOQhD3nIQx4i4IaiUETahGCNGtrMYg6/gTNFl943ziWcSw8OyY20hLT0gFBtalu01d7RL7VtenVUNQKtaEbRoDZ9hp2nKYwTMl6I9mq0w6ZdP+2D7J3zi3wBZ7CTF87er0cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4bb.png
// module id = 1010
// module chunks = 0